import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TemplateIntroduceComp'
}

import Introduce from '../components/Introduce'

import { computed, provide, withDefaults, ref } from 'vue'
import { isLongIOS } from '@/canvas/utils'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    component: null
  },
  setup(__props: any) {

const props = __props as { component: {
      name: string
      compId: string
      data: {
        content: {
          introduce: string
          advantage: string
          imgList: string[]
        }
      }
    } };


const content = computed(() => {
  return props.component?.data?.content || {}
})

const isLongIOSBool = ref<boolean>(isLongIOS as boolean)

const buttonStyle = computed(() => {
  return {
    paddingBottom: isLongIOSBool.value ? '118px' : '84px'
  }
})

provide('name', props.component.name)
provide('compId', props.component.compId)

return { __sfc: true,props, content, isLongIOSBool, buttonStyle, Introduce }
}

})